<Video
  src="/changelog/credits-1-29.mp4"
  poster="/changelog/credits-1-29-poster.webp"
  label="Recorrido por Créditos: el listado, el expediente paso a paso, el aviso al cliente, la aprobación y Postventa"
/>

Esta actualización incorpora **Créditos**, el módulo para llevar el trámite de financiamiento de cada venta cerrada, desde el primer contacto con el banco hasta que la unidad queda lista para entregar.

Cada crédito tiene su expediente con un recorrido de siete etapas. Marcas los puntos a medida que avanzan, el cliente y el equipo reciben los avisos que correspondan sin que tengas que escribir un correo, y cuando el crédito se aprueba, Postventa lo ve listo para coordinar la entrega.

---

## Todos los créditos en una sola vista

El listado muestra las negociaciones cerradas y en qué etapa va el crédito de cada una.

- Indicadores de un vistazo: total, en proceso, no iniciados y aprobados
- Pestañas para enfocarte en lo que necesitas: **En proceso**, **Próximos** (los que están por arrancar), **No iniciados** y **Aprobados**
- Búsqueda por inmueble o código, y filtros por etapa, modalidad, proyecto y fechas
- Un panel lateral con dónde va el trámite, su recorrido, los documentos y la actividad, sin salir del listado

---

## El expediente, paso a paso

Al abrir un crédito ves su **Recorrido del crédito** con las siete etapas: inicio y contacto a cliente, integración de expediente, avalúos, validación financiera, facturación, formalización y escrituración, y desembolso y entrega.

- **Una pregunta a la vez:** cada punto aparece como una pregunta, con los datos y documentos que pide
- Marca y continúa con un clic o con **Enter**; si todavía no tienes el dato, **Saltar por ahora** te lleva al siguiente
- Los campos obligatorios se piden antes de avanzar de etapa, para que nada quede a medias
- Cuando una etapa tiene todos sus puntos marcados, la cierras con **Avanzar etapa**
- **Ver todo** muestra el expediente completo en una sola página
- Si la venta es de contado, el recorrido omite las etapas que no aplican

---

## Avisos automáticos al cliente y al equipo

Los avisos salen solos cuando el expediente llega a los momentos que importan. Por ejemplo, cuando registras que el banco **aprobó** la solicitud, el cliente recibe un correo con la marca del proyecto que le explica qué sigue.

- Correos al cliente con el diseño de la marca del proyecto
- Avisos internos para que el equipo sepa cuándo le toca actuar
- Cada envío queda en la **Bitácora** del expediente, con el aviso, sus destinatarios y el momento en que salió; si un aviso no se pudo enviar, también lo verás ahí

---

## Aprobación y Postventa

Cuando se marca el último punto de **Desembolso y entrega**, el crédito queda **Aprobado**.

- El expediente cambia su estado y te ofrece **Abrir Postventa** en lugar de **Ver negociación**
- En Postventa, la columna **Crédito** pasa a **Listo para entrega** y el indicador de listos para entrega se actualiza
- Nadie tiene que avisar a mano: Postventa ve el cambio en cuanto ocurre

---

## Bitácora del crédito

Todo lo que pasa en el expediente queda registrado: quién lo abrió, qué puntos se marcaron y con qué respuesta, cuándo avanzó cada etapa y qué avisos se enviaron.
